import React, { useState } from 'react';
import { Button, Modal, Form, Spinner, Alert } from 'react-bootstrap';
import axios from 'axios';
import authConfig from '../../authConfig';
import MemberFutureMeetingsSelector from './MemberFutureMeetingsSelector';
import { useSelector, useDispatch } from "react-redux";
import { setLoginState, logout } from "../../redux/authSlice";
import MemberAttendanceTypeSelector from './MemberAttendanceTypeSelector';

const MemberApologyForm = ({ onSubmit }) => {
    const [reason, setReason] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [show, setShow] = useState(false);
    const [meeting, setMeeting] = useState(null);
    const [showSummary, setShowSummary] = useState(false);
    const [summaryData, setSummaryData] = useState(null);
    const [error, setError] = useState(null);
    const [attendanceType, setAttendanceType] = useState('');

    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const member = useSelector(state => state.auth.user ? state.auth.user : null);

    const meetingdateformatted = meeting == null ? "" : (new Date(meeting.date)).toLocaleString();

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
        setReason('');
        setMeeting(null);
        setSubmitting(false);
        setShowSummary(false);
        setSummaryData(null);
    };
    const handleMeetingSelect = (e) => {
        setMeeting(e);
    }
    const selectAttendanceType = (e) => {
        setAttendanceType(e);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError(null);

        if (!member || !meeting || attendanceType=='') {
            setError("Member and meeting must be selected.");
            setSubmitting(false);
            return;
        }

        try {
            await axios.post(
                authConfig.api.urls.getMemberSubmitApology,
                {
                    memberId: member.memberId,
                    meetingId: meeting.id,
                    reason: reason,
                    type: attendanceType,
                },
                { withCredentials: true }
                 // ensure this includes credentials/cookies if needed
            );
            setShow(false);
            setSummaryData({
                memberName: member.fullname,
                meetingDate: meetingdateformatted,
                type: attendanceType,
                reason: reason
            });
            setShowSummary(true);
        } catch (err) {
            setError("Failed to submit apology.");
        }
        setSubmitting(false);
    };

    return (
        <>
            <Button variant="success" onClick={handleShow}>
                Submit Apology
            </Button>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Submit Apology</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <MemberFutureMeetingsSelector
                            onSelect={handleMeetingSelect}
                            label="Select meeting for apology"
                            required={true}
                        />
                        <Form.Group>
                            <Form.Label>Apology Type</Form.Label>
                            <MemberAttendanceTypeSelector onSelect={selectAttendanceType} required={true} />
                        </Form.Group>
                        <Form.Group controlId="apology-reason" className="mt-3">
                            <Form.Label>Reason</Form.Label>
                            <Form.Control
                                as="textarea"
                                value={reason}
                                onChange={e => setReason(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose} disabled={submitting}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit" disabled={submitting}>
                            {submitting ? <Spinner animation="border" size="sm" /> : 'Submit Apology'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal show={showSummary} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Apology Submitted</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="success">
                        <div><strong>Member:</strong> {summaryData?.memberName}</div>
                        <div><strong>Apology Type:</strong> {summaryData?.type}</div>
                        <div><strong>Meeting Date:</strong> {summaryData?.meetingDate}</div>
                        <div><strong>Reason:</strong> {summaryData?.reason}</div>
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default MemberApologyForm;